import { useState } from 'react';
import PropTypes from 'prop-types';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

Team.propTypes = {
    data: PropTypes.array
};

function Team(props) {

    const {data} = props;

    const [dataBlock] = useState(
        {
            subheading: 'What I Do',
            heading: 'Services I Offer',
        }
    )

    return (
        <section className="team">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center">
                            <h6 className="sub-heading"><span>{dataBlock.subheading}</span></h6>
                            <h3 className="heading pd">{dataBlock.heading}</h3>
                        </div>

                        <Swiper
                                className="team-swiper"
                                spaceBetween={30}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1,
                                        },
                                    500: {
                                        slidesPerView: 2,
                                    },
                                    768: {
                                        slidesPerView: 3,
                                    },
                                    991: {
                                        slidesPerView: 4,
                                    },
                                }}
                                loop={true}

                            >

                                {
                                    data.map(idx => (
                                        <SwiperSlide key={idx.id}>
                                            <div className="swiper-slide">
                                                <div className="team-box">
                                                    <div className="image" style={{ background: 'linear-gradient(135deg, rgba(92,39,254,0.15) 0%, rgba(222,199,255,0.08) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 0' }}>
                                                        <img src={idx.img} alt={idx.name} style={{ width: 64, height: 64, objectFit: 'contain' }} />
                                                    </div>
                                                    <div className="content">
                                                        <p className="h5 name" style={{ fontWeight: 700, fontSize: 16, color: '#fff', marginBottom: 6 }}>{idx.name}</p>
                                                        <p className="postion" style={{ fontSize: 12, marginBottom: 10 }}>
                                                            {idx.position}
                                                        </p>
                                                        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, marginBottom: 0 }}>{idx.desc}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                }

                            </Swiper>


                    </div>

                </div>
            </div>
        </section>
    );
}

export default Team;
